import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { constant } from '../app.constants';
import {
  IComplaintDashboardFilterOptions,
  IComplaintDashboardSummary,
  IComplaintDashboardSummaryRequest,
  IComplaintDashboardTrendItem,
  IComplaintDashboardTrendRequest
} from '../core/interfaces/complaints-dashboard.interface';
import { ParentService } from '../pages/A2-utils/ParentClass/ParentService';

@Injectable()
export class ComplaintsService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
  }

  getStatus() {
    const url = constant.URL_TRIP_NOTES + '/NoteCategoryValues?noteCategoryValueId=5';
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  getNoteCategoryValues(id) {
    const url = constant.URL_TRIP_NOTES + `/NoteCategoryValues?noteCategoryValueId=${id}`;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  getComplaints(startDate, endDate, noteStatusId, isdateofservice) {
    const url = constant.URL_TRIP_NOTES +
    `/List/Complaint?startDate=${startDate}&endDate=${endDate}&noteStatusId=${noteStatusId}&isdateofservice=${isdateofservice}`;
    return this._http.get(url, this.getHeader())
      .map(res => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getHistorySearchByNote(noteId) {
    const url = constant.URL_COMPLAINT_HISTORY_SEARCH_BY_NOTE + `${noteId}`;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  putTripNote(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_TRIP_NOTES, bodyString, this.headerPost())
    .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  managerComplaintHistory(data: any, option: string) {
    option === 'POST'? delete data.ComplaintHistoryId: '';
    const bodyString = JSON.stringify(data);
    if (option === 'PUT') {
      return this._http.put(constant.COMPLAINT_HISTORY, bodyString, this.headerPost())
      .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json()));
    } else if(option === 'POST'){
      return this._http.post(constant.COMPLAINT_HISTORY, bodyString, this.headerPost())
      .map((res: Response) => res.json())
        .catch((error: any) => Observable.throw(error.json()));
    }
  }

  getComplaintsHeader(tripnoteid: number) {
    const url = constant.URL_TRIP_NOTES + `/${tripnoteid}`;
    return this._http.get(url, this.getHeader()).map(
      res => res.json()
    );
  }

  getFileAttachment(complainthistoryid: number) {
    return this._http.get(`${constant.URL_COMPLAINT_HISTORY_FILE}${complainthistoryid}`, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getDashboardFilters(): Observable<IComplaintDashboardFilterOptions> {
    return this._http.get(constant.COMPLAINT_DASHBOARD + '/Filters', this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: Response) => Observable.throw(error.json()));
  }

  getDashboardSummary(request: IComplaintDashboardSummaryRequest): Observable<IComplaintDashboardSummary> {
    return this.postDashboard<IComplaintDashboardSummary>('Summary', request);
  }

  getDashboardTrend(request: IComplaintDashboardTrendRequest): Observable<IComplaintDashboardTrendItem[]> {
    return this.postDashboard<IComplaintDashboardTrendItem[]>('Trend', request);
  }

  private postDashboard<T>(
    endpoint: string,
    request: IComplaintDashboardSummaryRequest | IComplaintDashboardTrendRequest
  ): Observable<T> {
    return this._http.post(constant.COMPLAINT_DASHBOARD + '/' + endpoint, JSON.stringify(request), this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: Response) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/complaints.service.ts